export enum EChatUserType {
  SENT = '0',
  RECEIVED = '1'
}

export type TChatUserType =
  | EChatUserType.SENT
  | EChatUserType.RECEIVED;

export enum EChatMessageType {
  TEXT = 0,
  FILE = 1,
  IMAGE = 2,
  VIDEO = 3
}

export type TChatMessageType =
  | EChatMessageType.TEXT
  | EChatMessageType.FILE
  | EChatMessageType.IMAGE
  | EChatMessageType.VIDEO;

export interface IChatMessage {
  id: number;
  time: string;
  date: string;
  name: string;
  message: string;
  userType: TChatUserType;
  messageType: TChatMessageType;
}

export interface IChatMessageProps {
  message: IChatMessage;
}

export interface IChatMessageDto {
  id: number;
  createDate: string;
  user: {
    id: string
    name: string
  };
  message: string;
  messageType: TChatMessageType;
}
